<template>
    <div class="animated fadeIn">
        <div class="support-screen">
            <div class="notes-and-support">
                <div class="release-notes">
                    <h1>Release Notes</h1>
                    <button @click="openCreateReleaseNote()" v-if="isAdmin && permissionGranted" class="btn btn-primary create-release-note-btn">Create Release Note</button>
                    <div v-if="isAdmin" class="release-notes-filters">
                        <a @click="setFilter('CUSTOMER_NOTES')" :class="selectedType == 'CUSTOMER_NOTES' ? 'selected' : ''">USER RELEASE NOTES</a>
                        <a @click="setFilter('SUPER_ADMIN_NOTES')" :class="selectedType == 'SUPER_ADMIN_NOTES' ? 'selected' : ''">ADMIN RELEASE NOTES</a>
                    </div>
                    <div v-if="releaseNotesList.length > 0" :class="['release-notes-box', isAdmin ? 'admin-view' : '']">
                        <div v-for="item of releaseNotesList" class="release-note">
                            <div class="note-header">
                                <h3>{{item.releaseDate}}</h3>
                                <div class="right-side">
                                    <h3>v. {{item.version}}</h3>
                                    <button @click="openEditNotes(item)" v-if="isAdmin && permissionGranted"><i class="fa fa-pencil"></i></button>
                                </div>
                            </div>
                            <p v-if="item.message != ''" class="note-description">{{item.message}}</p>
                            <div v-if="item.improvements.length" class="notes-list improvements">
                                <div class="notes-list-header">
                                    <img src="../../assets/img/improvements-icon.svg" alt="">
                                    <h3>Improvements</h3>
                                </div>
                                <ul>
                                    <li v-for="listItem of item.improvements">{{listItem}}</li>
                                </ul>
                            </div>
                            <div v-if="item.fixes.length" class="notes-list fixes">
                                <div class="notes-list-header">
                                    <img src="../../assets/img/fixes-icon.svg" alt="">
                                    <h3>Fixes</h3>
                                </div>
                                <ul>
                                    <li v-for="listItem of item.fixes">{{listItem}}</li>
                                </ul>
                            </div>
                            <div v-if="item.newFeatures.length" class="notes-list new-features">
                                <div class="notes-list-header">
                                    <img src="../../assets/img/new-features-icon.svg" alt="">
                                    <h3>New Features</h3>
                                </div>
                                <ul>
                                    <li v-for="listItem of item.newFeatures">{{listItem}}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div v-if="releaseNotesList.length == 0 && loading == false" class="no-release-notes">
                        <h2>There is no Release Notes to display</h2>
                    </div>
                    <div class="loader-release-notes-list" v-if="loading">
                        <div class="sk-wave">
                            <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                        </div>
                    </div>
                </div>
                <div class="support-info">
                    <h4>Portal Vesion</h4>
                    <h2>{{currentVersion}}</h2>
                    <img src="../../assets/img/suppport-icon.png" alt="">
                    <h3>Need Help? Contact Support</h3>
                    <p class="support-info-text">We are available 24 hrs/day, 7 days/week</p>
                    <p class="support-info-text">Please feel free to contact us anytime you have questions</p>
                    <p class="contact-data">e-mail <a href="mailto:support@simoniot.com">support@simoniot.com</a></p>
                    <p class="contact-data">Phone <a href="tel:1-833-746-6646">1-833-746-6646</a></p>
                    <div class="support-footer">
                        <a class="bolded" href="https://simoniot.com">www.simoniot.com</a>
                        <p>Simon IoT© 2021 Simon IoT LLC.</p>
                        <a @click="showTermsConditions()">Terms & Conditions</a>
                    </div>
                </div>
            </div>
        </div>
        <b-modal ref="createReleaseNotes" id="createReleaseNotes" size="md" hide-header hide-footer centered>
            <i @click="closeCreateReleaseNote()" class="fa fa-close"></i>
            <div class="header-row">
                <img src="../../assets/img/announcement-icon.svg" alt="">
                <h3>Create Release Note</h3>
            </div>
            <div class="set-type-row">
                <div class="customer-type-row">
                    <div class="custom-control custom-radio custom-control-inline">
                        <input v-model="noteType" type="radio" id="customerRadio" name="releaseType" class="custom-control-input" :checked="noteType == 'CUSTOMER_NOTES'" value="CUSTOMER_NOTES"/>
                        <label class="custom-control-label" for="customerRadio">Customer Release Note</label>
                    </div>
                    <div v-if="noteType == 'CUSTOMER_NOTES'" class="switch-box">
                        <c-switch v-model="announcementRequired" cclass="mx-1" color="primary" variant="pill" label dataOn="✓" dataOff="✕"/>
                        <label>Announcement required</label>
                    </div>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input v-model="noteType" type="radio" id="SARadio" name="releaseType" class="custom-control-input" :checked="noteType == 'SUPER_ADMIN_NOTES'" value="SUPER_ADMIN_NOTES"/>
                    <label class="custom-control-label" for="SARadio">SA Release Note</label>
                </div>
            </div>
            <div class="release-date-version-row">
                <div class="date-box">
                    <h4>Release Date</h4>
                    <date-picker v-model="releaseNoteDate" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                    <span v-if="errorMsgs.date != ''" class="error-msg">{{errorMsgs.date}}</span>
                </div>
                <div class="version-box">
                    <h4>Version</h4>
                    <input type="text" v-model="versionValue"/>
                    <span v-if="errorMsgs.version != ''" class="error-msg">{{errorMsgs.version}}</span>
                </div>
            </div>
            <div class="textarea-box">
                <div class="header-row">
                    <label for="description">Description</label>
                    <span>Optional</span>
                </div>
                <textarea v-model="noteDesc" id="description" rows="2"></textarea>
            </div>
            <div class="textarea-box">
                <div class="header-row">
                    <label for="improvements">Improvements</label>
                    <i class="fa fa-info-circle">
                        <span>Add Enter between notes to make them separated elements.</span>
                    </i>
                </div>
                <textarea v-model="noteImprovements" id="improvements" rows="4"></textarea>
                <span v-if="errorMsgs.content != ''" class="error-msg">{{errorMsgs.content}}</span>
            </div>
            <div class="textarea-box">
                <div class="header-row">
                    <label for="fixes">Fixes</label>
                    <i class="fa fa-info-circle">
                        <span>Add Enter between notes to make them separated elements.</span>
                    </i>
                </div>
                <textarea v-model="noteFixes" id="fixes" rows="4"></textarea>
                <span v-if="errorMsgs.content != ''" class="error-msg">{{errorMsgs.content}}</span>
            </div>
            <div class="textarea-box">
                <div class="header-row">
                    <label for="newFeatures">New Features</label>
                    <i class="fa fa-info-circle">
                        <span>Add Enter between notes to make them separated elements.</span>
                    </i>
                </div>
                <textarea v-model="noteNewFeatures" id="newFeatures" rows="4"></textarea>
                <span v-if="errorMsgs.content != ''" class="error-msg">{{errorMsgs.content}}</span>
            </div>
            <div class="control-bar">
                <div class="left-side">
                </div>
                <div class="right-side">
                    <button @click="closeCreateReleaseNote()" class="btn btn-light">Cancel</button>
                    <button @click="createNote()" class="btn btn-primary">Create</button>
                </div>
            </div>
        </b-modal>
        <b-modal ref="editReleaseNotes" id="editReleaseNotes" size="md" hide-header hide-footer centered>
            <i class="fa fa-close" @click="closeEditReleaseNote()"></i>
            <div class="header-row">
                <img src="../../assets/img/announcement-icon.svg" alt="">
                <h3>Edit Release Note</h3>
            </div>
            <div class="set-type-row">
                <div class="custom-control custom-radio custom-control-inline">
                    <input v-model="editNote.noteType" type="radio" id="editCustomerRadio" name="releaseType" class="custom-control-input" :checked="editNote.noteType == 'CUSTOMER_NOTES'" value="CUSTOMER_NOTES"/>
                    <label class="custom-control-label" for="editCustomerRadio">Customer Release Note</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input v-model="editNote.noteType" type="radio" id="editSARadio" name="releaseType" class="custom-control-input" :checked="editNote.noteType == 'SUPER_ADMIN_NOTES'" value="SUPER_ADMIN_NOTES"/>
                    <label class="custom-control-label" for="editSARadio">SA Release Note</label>
                </div>
            </div>
            <div class="release-date-version-row">
                <div class="date-box">
                    <h4>Release Date</h4>
                    <date-picker v-model="editNote.releaseDate" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                    <span v-if="errorMsgs.date != ''" class="error-msg">{{errorMsgs.date}}</span>
                </div>
                <div class="version-box">
                    <h4>Version</h4>
                    <input type="text" v-model="editNote.version"/>
                    <span v-if="errorMsgs.version != ''" class="error-msg">{{errorMsgs.version}}</span>
                </div>
            </div>
            <div class="textarea-box">
                <div class="header-row">
                    <label for="editDescription">Description</label>
                    <span>Optional</span>
                </div>
                <textarea v-model="editNote.message" id="editDescription" rows="2"></textarea>
            </div>
            <div class="textarea-box">
                <div class="header-row">
                    <label for="editImprovements">Improvements</label>
                    <i class="fa fa-info-circle">
                        <span>Add Enter between notes to make them separated elements.</span>
                    </i>
                </div>
                <textarea v-model="editNote.improvements" id="editImprovements" rows="4"></textarea>
                <span v-if="errorMsgs.content != ''" class="error-msg">{{errorMsgs.content}}</span>
            </div>
            <div class="textarea-box">
                <div class="header-row">
                    <label for="editFixes">Fixes</label>
                    <i class="fa fa-info-circle">
                        <span>Add Enter between notes to make them separated elements.</span>
                    </i>
                </div>
                <textarea v-model="editNote.fixes" id="editFixes" rows="4"></textarea>
                <span v-if="errorMsgs.content != ''" class="error-msg">{{errorMsgs.content}}</span>
            </div>
            <div class="textarea-box">
                <div class="header-row">
                    <label for="editNewFeatures">New Features</label>
                    <i class="fa fa-info-circle">
                        <span>Add Enter between notes to make them separated elements.</span>
                    </i>
                </div>
                <textarea v-model="editNote.newFeatures" id="editNewFeatures" rows="4"></textarea>
                <span v-if="errorMsgs.content != ''" class="error-msg">{{errorMsgs.content}}</span>
            </div>
            <div class="control-bar">
                <div class="left-side">
                    <button @click="deleteEditNote()" class="delete-btn">DELETE</button>
                </div>
                <div class="right-side">
                    <button @click="closeEditReleaseNote()" class="btn btn-light">Cancel</button>
                    <button @click="saveEditNote()" class="btn btn-primary">Save</button>
                </div>
            </div>
        </b-modal>
        <b-modal hide-footer id="terms" ref="terms" size="lg" class="terms" centered>
            <div class="terms-and-conditions-topbar">
                <div class="logo-container">
                    <img src="../../assets/img/lightlogo.svg" class="light-version" alt="SimonIoT Logo">
                    <img src="../../assets/img/darklogo.svg" class="dark-version" alt="SimonIoT Logo">
                </div>
                <h3>Terms and conditions</h3>
            </div>
            <div class="terms-and-conditions-text" v-html="termsContent"></div>
        </b-modal>
    </div>
</template>

<script>
    import Axios from 'axios'
    import globalStore from "../../variables";
    import DatePicker from 'vue2-datepicker'
    import { Switch as cSwitch } from '@coreui/vue'

    export default {
        name: 'Support',
        components: {
            DatePicker,
            cSwitch
        },
        data() {
            return {
                isAdmin: false,
                permissionGranted: false,
                releaseNotesList: [],
                currentVersion: null,
                langDataPicker: {
                    days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
                    placeholder: {
                        date: 'Select Date',
                        dateRange: 'Select Date'
                    }
                },
                releaseNoteDate: null,
                noteType: 'SUPER_ADMIN_NOTES',
                selectedType: 'CUSTOMER_NOTES',
                versionValue: null,
                announcementRequired: false,
                noteDesc: '',
                noteImprovements: '',
                noteFixes: '',
                noteNewFeatures: '',
                errorMsgs: {
                    date: '',
                    version: '',
                    content: ''
                },
                editNote: {
                    id: 0,
                    fixes: '',
                    improvements: '',
                    newFeatures: '',
                    noteType: '',
                    version: '',
                    releaseDate: '',
                    message: ''
                },
                termsContent: '',
                loading: false
            }
        },
        methods: {
            getReleaseNotes() {
                this.loading = true
                Axios.get(globalStore.data.restApiUrl + '/release-notes/' + this.selectedType)
                    .then(response => {
                        this.releaseNotesList = []
                        if (response.data.length) {
                            for (let item of response.data) {
                                let template = item
                                template.fixes = []
                                template.improvements = []
                                template.newFeatures = []
                                for (let el of template.releaseNoteElements) {
                                    if (el.noteElementType == 'FIX') {
                                        template.fixes.push(el.elementContent)
                                    } else if (el.noteElementType == 'IMPROVEMENT') {
                                        template.improvements.push(el.elementContent)
                                    } else if (el.noteElementType == 'NEW_FEATURE') {
                                        template.newFeatures.push(el.elementContent)
                                    }
                                }
                                delete template.releaseNoteElements
                                this.releaseNotesList.push(template)
                            }
                        }
                        this.loading = false
                    })
                    .catch(error => {
                        this.loading = false
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Release notes getting error',
                            text: 'An error has occured during getting release notes data. Please contact support.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            },
            openCreateReleaseNote() {
                this.$refs['createReleaseNotes'].show();
            },
            closeCreateReleaseNote() {
                this.$refs['createReleaseNotes'].hide();
                this.versionValue = ''
                this.noteType = 'SUPER_ADMIN_NOTES'
                this.releaseNoteDate = null
                this.errorMsgs = {
                    date: '',
                    version: '',
                    content: '',
                }
                this.noteImprovements = ''
                this.noteFixes = ''
                this.noteNewFeatures = ''
                this.noteDesc = ''
            },
            parseFromArrayToString(arr) {
                let final = ''
                if (arr.length > 0) {
                    let array = arr
                    for (let item of arr) {
                        final = final + item + '\n'
                    }
                    final = final.substr(0,final.length - 1)
                }
                return final
            },
            openEditNotes(note) {
                this.editNote.fixes = this.parseFromArrayToString(note.fixes)
                this.editNote.improvements = this.parseFromArrayToString(note.improvements)
                this.editNote.newFeatures = this.parseFromArrayToString(note.newFeatures)
                this.editNote.id = note.notesId
                this.editNote.noteType = note.notesType
                this.editNote.message = note.message
                this.editNote.version = note.version
                let date = new Date(note.releaseDate)
                this.editNote.releaseDate = date.getFullYear() + '-' + ("0" + (date.getMonth() + 1)).substr(-2) + '-' + ("0" + (date.getDate())).substr(-2)
                this.$refs['editReleaseNotes'].show();
            },
            closeEditReleaseNote() {
                this.$refs['editReleaseNotes'].hide();
                this.editNote = {
                    id: 0,
                    fixes: '',
                    improvements: '',
                    newFeatures: '',
                    noteType: '',
                    version: '',
                    releaseDate: '',
                    message: ''
                }
            },
            parseTextAreaValueToArray(val) {
                let str = val
                let arr = []
                if (str.indexOf('\n') != -1) {
                    arr = str.replace(/\n/g,',').split(',')
                } else {
                    arr = [str]
                }
                return arr
            },
            saveEditNote() {
                this.errorMsgs = {
                    date: '',
                    version: '',
                    content: '',
                }
                let errorCount = 0
                if (this.editNote.releaseDate == null || this.editNote.releaseDate == '') {
                    errorCount++
                    this.errorMsgs.date = 'Date must be set'
                }
                if (this.editNote.version == null || this.editNote.version == '') {
                    errorCount++
                    this.errorMsgs.version = 'Version must be set'
                }
                if (this.editNote.fixes == '' && this.editNote.improvements == '' && this.editNote.newFeatures == '') {
                    errorCount++
                    this.errorMsgs.content = 'Any of fields must be filled'
                }
                if (errorCount) {
                    return false
                }

                let parsedData = {
                    message: this.editNote.message,
                    releaseDate: this.editNote.releaseDate,
                    version: this.editNote.version,
                    notesType: this.editNote.noteType,
                    notesElements: []
                }

                for (let item of this.parseTextAreaValueToArray(this.editNote.fixes)) {
                    parsedData.notesElements.push({content: item, elementType: 'FIX'})
                }

                for (let item of this.parseTextAreaValueToArray(this.editNote.improvements)) {
                    parsedData.notesElements.push({content: item, elementType: 'IMPROVEMENT'})
                }

                for (let item of this.parseTextAreaValueToArray(this.editNote.newFeatures)) {
                    parsedData.notesElements.push({content: item, elementType: 'NEW_FEATURE'})
                }

                Axios.put(globalStore.data.restApiUrl + '/release-notes/update?notesId=' + this.editNote.id, parsedData)
                    .then(response => {
                        this.getReleaseNotes()
                        this.closeEditReleaseNote();
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Release Note edited',
                            text: 'You successfully edited note in database.',
                            duration: 5000,
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Editing notes error',
                            text: 'An error has occured during editing note.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            },
            deleteEditNote() {
                Axios.delete(globalStore.data.restApiUrl + '/release-notes/delete?notesId=' + this.editNote.id)
                    .then(response => {
                        this.getReleaseNotes()
                        this.closeEditReleaseNote()
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Release Note deleted',
                            text: 'You successfully removed note from database.',
                            duration: 5000,
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Deleting notes error',
                            text: 'An error has occured during deleting note from database.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            },
            createNote() {
                let parsedData = {
                    notesElements: [],
                    version: this.versionValue,
                    notesType: this.noteType,
                    releaseDate: this.releaseNoteDate
                }
                this.errorMsgs = {
                    date: '',
                    version: '',
                    content: '',
                }
                let errorCount = 0
                if (this.releaseNoteDate == null || this.releaseNoteDate == '') {
                    errorCount++
                    this.errorMsgs.date = 'Date must be set'
                }
                if (this.versionValue == null || this.versionValue == '') {
                    errorCount++
                    this.errorMsgs.version = 'Version must be set'
                }
                if (this.noteImprovements == '' && this.noteFixes == '' && this.noteNewFeatures == '') {
                    errorCount++
                    this.errorMsgs.content = 'Any of fields must be filled'
                }
                if (errorCount) {
                    return false
                }

                if (this.noteType == 'CUSTOMER_NOTES') {
                    parsedData.announcementRequired = this.announcementRequired
                }

                if (this.noteDesc.length > 0) {
                    parsedData.message = this.noteDesc
                }
                if (this.noteImprovements != '') {
                    for (let item of this.parseTextAreaValueToArray(this.noteImprovements)) {
                        parsedData.notesElements.push({content: item, elementType: 'IMPROVEMENT'})
                    }
                }
                if (this.noteFixes != '') {
                    for (let item of this.parseTextAreaValueToArray(this.noteFixes)) {
                        parsedData.notesElements.push({content: item, elementType: 'FIX'})
                    }
                }
                if (this.noteNewFeatures != '') {
                    for (let item of this.parseTextAreaValueToArray(this.noteNewFeatures)) {
                        parsedData.notesElements.push({content: item, elementType: 'NEW_FEATURE'})
                    }
                }

                Axios.post(globalStore.data.restApiUrl + '/release-notes/add', parsedData)
                    .then (response => {
                        this.getReleaseNotes()
                        this.closeCreateReleaseNote()
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Release notes saved',
                            text: 'You successfully created Release Note.',
                            duration: 5000,
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Release notes saving error',
                            text: 'An error has occured during saving release notes.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            },
            setFilter(type) {
                this.selectedType = type
                this.getReleaseNotes()
            },
            showTermsConditions() {
                this.getTermsContent();
            },
            getTermsContent() {
                Axios.get(globalStore.data.restApiUrl + '/terms-and-conditions/most-recent')
                    .then(response => {
                        this.termsContent = response.data.content;
                        this.$refs['terms'].show();
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            getVersion () {
                Axios.get(globalStore.data.restApiUrl + '/release-notes/version')
                    .then(response => {
                        this.currentVersion = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        },
        mounted() {
            let today = new Date();
            this.releaseNoteDate = today.getFullYear() + '-' + ("0" + (today.getMonth() + 1)).slice(-2) + '-' + ("0" + today.getDate()).slice(-2);
            this.getVersion()
            if (this.$session.get('token') && this.$session.get('companyId') == undefined) {
                this.isAdmin = true
                if (this.$session.get('saPermissions').indexOf('MANAGE_RELEASE_NOTES') > -1) {
                    this.permissionGranted = true
                }
                this.selectedType = 'SUPER_ADMIN_NOTES'
                this.getReleaseNotes()
            } else {
                this.selectedType = 'CUSTOMER_NOTES'
                this.getReleaseNotes()
            }
        }
    }
</script>

<style lang="scss" scoped>
.support-screen {
    padding: 20px;
    margin-bottom: 20px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    background-color: #fff;
    border: 1px solid #c8ced3;
    h1 {
        margin: 0 0 20px;
        font-size: 15px;
        font-weight: 700;
    }
    .create-release-note-btn {
        margin-bottom: 20px;
    }

    .release-notes-filters {
        margin-bottom: 20px;
        a {
            margin-right: 30px;
            font-size: 14px;
            font-weight: 700;
            cursor: pointer;
            &.selected {
                color: #0088ff;
                pointer-events: none;
            }
        }
    }

    .notes-and-support {
        display: flex;
        flex-wrap: nowrap;

        .release-notes {
            position: relative;
            flex-grow: 1;
            .release-notes-box {
                max-height: calc(100vh - 221px);
                overflow: auto;
                padding-right: 20px;
                &.admin-view {
                    max-height: calc(100vh - 317px);
                }
            }
            .release-note {
                margin-bottom: 20px;
                padding: 20px;
                background-color: #fcfcfc;
                border: 1px solid #C9CFD4;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                &:last-child {
                    margin-bottom: 0;
                }
                .note-header {
                    display: flex;
                    justify-content: space-between;
                    h3 {
                        margin: 0;
                        font-size: 15px;
                        font-weight: 700;
                    }
                    .right-side {
                        display: flex;
                        button {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 32px;
                            height: 32px;
                            margin-left: 20px;
                            background-color: #fcfcfc;
                            border: 1px solid #C9CFD4;
                            -webkit-border-radius: 5px;
                            -moz-border-radius: 5px;
                            border-radius: 5px;
                            i {
                                margin: 0;
                                color: #0088ff;
                            }
                        }
                    }
                }
                .notes-list {
                    margin-bottom: 32px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                    ul {
                        margin-bottom: 0;
                    }
                    .notes-list-header {
                        display: flex;
                        align-items: center;
                        max-width: 170px;
                        padding: 8px 10px;
                        margin-bottom: 12px;
                        background-color: #f2f2f2;
                        -webkit-border-radius: 5px;
                        -moz-border-radius: 5px;
                        border-radius: 5px;
                        h3 {
                            margin: 0 0 0 10px;
                            font-size: 15px;
                        }
                    }
                    ul {
                        padding-left: 20px;
                    }
                }
            }
            .no-release-notes {
                padding: 20px;
                background-color: #fcfcfc;
                border: 1px solid #C9CFD4;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                h2 {
                    margin: 0;
                    text-align: center;
                    font-size: 18px;
                    font-weight: 700;
                }
            }
            .loader-release-notes-list {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;

                background-color: rgba(255, 255, 255, 0.7);

                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                align-content: center;

                .sk-wave {
                    height: 60px;
                    .sk-rect {
                        width: 3px;
                        background-color: #39c354;
                        border-radius: 4px;
                    }
                }

                .text {
                    margin-top: 20px;
                    text-align: center;
                    font-size: 15px;
                    font-weight: 700;
                }
            }
        }
        .support-info {
            display: flex;
            flex-direction: column;
            align-items: center;
            min-width: 380px;
            margin-left: 40px;
            h4 {
                margin: 0 0 6px;
                font-size: 14px;
            }
            h2 {
                margin: 0 0 35px;
                font-size: 20px;
            }
            img {
                margin: 0 0 20px;
            }
            h3 {
                margin: 0 0 20px;
                font-size: 18px;
                font-weight: 700;
            }
            .support-info-text {
                margin: 0;
                line-height: 24px;
                color: #2F353A;
            }

            .contact-data {
                margin: 20px 0 0;
                font-size: 15px;
                line-height: 24px;
                color: #2F353A;

                a {
                    font-weight: 700;
                    color: #2F353A;
                }
            }
            .support-footer {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 40px 0 0;
                * {
                    margin: 0 0 9px;
                    font-size: 14px;
                    &:last-child {
                        margin: 0;
                    }
                }
                a {
                    color: #00B1FF;
                    cursor: pointer;
                }
                .bolded {
                    font-weight: 700;
                }
            }
        }
    }
}

#createReleaseNotes___BV_modal_body_,
#editReleaseNotes___BV_modal_body_ {
    position: relative;
    .fa-close {
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
    }
    .header-row {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        img {
            height: 24px;
            width: auto;
            margin-right: 14px;
        }
        h3 {
            margin: 0;
            font-size: 15px;
        }
    }
    .error-msg {
        position: absolute;
        bottom: -10px;
        left: 0;
        font-size: 12px;
        color: #9f191f;
    }
    .set-type-row {
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;
        .customer-type-row {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            .switch-box {
                display: flex;
                align-items: center;
                label {
                    margin: 0 0 0 12px;
                }
            }
        }
        .custom-control-input:checked ~ .custom-control-label::before {
            background-color: #fff;
            border-color: #000;
        }
        .custom-control-input:checked ~ .custom-control-label::after {
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='black'/%3e%3c/svg%3e");
        }
    }
    .release-date-version-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        .date-box,
        .version-box {
            position: relative;
            width: calc(50% - 10px);
            h4 {
                margin-bottom: 10px;
                font-size: 14px;
                font-weight: 400;
            }
            .error-msg {
                bottom: -16px;
            }
        }
        .date-box {
            .mx-datepicker {
                width: 100%;
            }
        }
        .version-box {
            input {
                width: 100%;
                padding: 7px 12px;
                background-color: #F0F3F5;
                border: 1px solid #C9CFD4;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                font-size: 12px;
                outline: none;
            }
        }
    }
    .textarea-box {
        position: relative;
        margin-bottom: 20px;
        .header-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
            label {
                margin: 0;
                font-size: 14px;
            }
            span {
                color: #727A82;
            }
            .fa-info-circle {
                position: relative;
                &:before {
                    color: #727A82;
                }
                span {
                    position: absolute;
                    bottom: 100%;
                    right: 100%;
                    display: none;
                    padding: 12px;
                    color: #000;
                    background-color: #f0f3f5;
                    border: 1px solid #C9CFD4;
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    white-space: nowrap;
                }
                &:hover {
                    span {
                        display: initial;
                    }
                }
            }
        }
        textarea {
            width: 100%;
            padding: 6px 12px;
            background-color: #f0f3f5;
            border: 1px solid #C9CFD4;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            outline: none;
        }
    }
    .control-bar {
        align-items: center;
        padding: 20px 0 0;
        border-top: 0;
        .delete-btn {
            border: 0;
            color: #FC4D4D;
            background-color: #fff;
            outline: 0;
            font-weight: 700;
        }
        .right-side {
            .btn {
                margin-right: 10px;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
}

#terms___BV_modal_content_ {
    background-color: #ffffff;
    color: #000000;

    .terms-and-conditions-topbar {
        display: flex;
        flex-direction: column;
        margin-bottom: 8px;

        .logo-container {
            display: flex;
            justify-content: center;
            margin: 20px 0;
            .dark-version {
                display: none;
            }
            .light-version {
                display: initial;
            }
        }

        h3 {
            font-size: 20px;
        }

        i {
            cursor: pointer;
            &:before {
                color: #000000;
            }
        }
    }

    .terms-and-conditions-text {
        width: 100%;
        max-height: calc(100vh - 330px);
        overflow: scroll;
        padding-right: 12px;
        h3 {
            font-size: 16px;
            font-weight: 700;
        }
    }

    .terms-and-conditions-text iframe {
        width: 100%;
        height: 70vh;
    }
}

@media screen and (max-width: 992px) {
    .support-screen {
        .notes-and-support {
            flex-direction: column-reverse;
            .support-info {
                width: 100%;
                min-width: 0;
                margin: 0 0 40px;
                p {
                    width: 100%;
                }
            }
        }
    }
}

.dark-theme {
    .support-screen {
        background-color: #3a4149;
        border-color: #1a1c1d;
        color: #fff;
        .notes-and-support {
            .release-notes {
                .loader-release-notes-list {
                    background-color: rgba(0, 0, 0, 0.4);
                }
                .no-release-notes {
                    background-color: #515b65;
                    border-color: #1a1c1d;
                }
                .release-note {
                    background-color: #515b65;
                    border-color: #1a1c1d;
                    .note-header {
                        .right-side {
                            button {
                                background-color: #3a4149;
                                border-color: #1a1c1d;
                            }
                        }
                    }
                    .notes-list {
                        .notes-list-header {
                            background-color: #3a4149;
                        }
                    }
                }
            }
            .support-info {
                .support-info-text,
                .contact-data {
                    color: #fff;
                }
                .contact-data {
                    a {
                        color: #fff;
                    }
                }
            }
        }
    }

    #createReleaseNotes___BV_modal_body_,
    #editReleaseNotes___BV_modal_body_ {
        .release-date-version-row {
            .version-box {
                input {
                    background-color: #515b65;
                    border-color: #1a1c1d;
                    color: #fff;
                }
            }
        }
        .textarea-box {
            textarea {
                background-color: #515b65;
                border-color: #1a1c1d;
                color: #fff;
            }
        }
        .control-bar {
            .delete-btn {
                background-color: transparent;
            }
        }
    }
}
</style>
